import React from 'react';

function SupaTest() {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

  return (
    <div>
      <h2>Supabase Environment Variables Test</h2>
      <p>URL exists: {supabaseUrl ? 'Yes' : 'No'}</p>
      <p>Key exists: {supabaseKey ? 'Yes' : 'No'}</p>
    </div>
  );
}

export default SupaTest;